import { addEventParam, INinjaEvent, useQueuedEventStore } from '@ninjacart/nc-events-sdk-v2';
import { KissanEventType, useGlobalLoginContext } from '@ninjacart/nc-nk-store';
import {
  Button,
  NinjacartLogo,
  Paragraph,
  UIBottomSheet,
  XStack,
  YStack,
} from '@ninjacart/nc-nk-ui';
import { useRouter } from '@ninjacart/nc-nk-web-deps';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export const GlobalLoginSheet = () => {
  const { t } = useTranslation();

  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;
  const { push } = useRouter();
  const fields = useGlobalLoginContext([
    'previousPage',
    'navigationParams',
    'openLoginSheet',
    'previousSessionName',
    'title',
  ]);
  const navigationParams: any = fields['navigationParams'].get;
  const previousPage = fields['previousPage'].get;
  const previousSessionName = fields['previousSessionName'].get;
  const title = fields['title'].get;
  
  useEffect(() => {
    if (navigationParams?.screenName) {
      const loginPopupevent: INinjaEvent = {
        name: KissanEventType.LOGIN_INITIATE_POPUP,
        screenDetails: { screen: navigationParams?.screenName },
        eventParams: [
          ...(previousPage
            ? [
                addEventParam('referenceKey1', 'previousPage'),
                addEventParam('referenceValue1', String(previousPage)),
              ]
            : []),
          ...(previousSessionName
            ? [
                addEventParam('referenceKey2', 'previousSessionName'),
                addEventParam('referenceValue2', String(previousSessionName)),
              ]
            : []),
          ...(title
            ? [
                addEventParam('referenceKey3', 'title'),
                addEventParam('referenceValue3', String(title)),
              ]
            : []),
        ],
      };
      enqueue(loginPopupevent);
    }
  }, [navigationParams?.screenName]);

  const navigateToLoginPage = () => {
    fields['openLoginSheet'].set(false);
    const bottomSheetLoginClickEvent: INinjaEvent = {
      name: KissanEventType.BOTTOMSHEET_LOGIN_CLICK,
      screenDetails: { screen: navigationParams?.screenName },
    };
    enqueue(bottomSheetLoginClickEvent);
    push('/login');
  };

  return (
    <UIBottomSheet
      open={fields['openLoginSheet'].get as boolean}
      animation={'quick'}
      snapPoints={[30]}
      onOpenChange={(open) => fields['openLoginSheet'].set(open)}
    >
      <>
        <YStack padding={10} flex={1}>
          <NinjacartLogo width={50} height={50} />
          <YStack paddingVertical={10} marginBottom={10}>
            <Paragraph fontSize={16} fontWeight={'600'} marginBottom={10}>
              {navigationParams?.description}
            </Paragraph>
          </YStack>
          <XStack paddingTop={20} alignContent="center">
            <Button
              backgroundColor={'$primary'}
              testID="kisan_tId_loginBottomSheetButton"
              onPress={navigateToLoginPage}
              theme="active"
              fontWeight={'600'}
              borderRadius="$2"
              color={'#fff'}
              width={'100%'}
              size="$6"
              alignContent={'center'}
            >
              {t('page.goToLogin')}
            </Button>
          </XStack>
        </YStack>
      </>
    </UIBottomSheet>
  );
};
